import { useEffect } from "react";
import { createSurfaceThreatLayer } from "../../lib/layers/threats";
import { useMap } from "./MapCanvas";

export default function FriendlySAMLayer({ groups, theater }) {
  const map = useMap();
  useEffect(() => {
    if (!map) {
      return;
    }

    const layer = createSurfaceThreatLayer(theater, groups, true);
    layer.set("hideable", true);
    layer.set("name", "Friendly SAMs");

    map.addLayer(layer);
  }, [map]);
  return null;
}
